module.exports = __webpack_public_path__ + "static/Classroom-Activity-2-4-Bullying-in-Our-School-What-Can-We-Do-0075aaded61fe84d4ce4908fa06fc33c.pdf";